import { pageConfig } from '@/common/service/page-config';
import { addToCartByPlanCode, de$type, planQueryParser, addToCart } from '@/common/service/flow/utils';
import _ from 'lodash';
import {
  planTypes,
  PBX_CATEGORYS,
} from '@/common/constants';
import { computedPbxBasePlans, computedPbxCallingPlans } from '@/common/service/computers/plans/pbx';
import getPbxBillingCycle from '@/plans/ZOOM_PHONE/helper/pbx-billing-cycle.js';
import { zoneBundleUtils } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import { addVendorProduct } from '@/flows/helper/vendor-product';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';

const addType = pageConfig?.editConfig?.planType;

const addZPCallingPlansByCategory = (planList, category, billingCycle) => {
  const pbxCallingPlans = computedPbxCallingPlans(planList);
  if(!pbxCallingPlans.length) return null;
  const pbxPlans$cycle = pbxCallingPlans.filter(item => item.billing_cycle === billingCycle);
  const categoryReg = new RegExp(`^${category}$`, 'i');
  const pbxPlans$cycle$category = pbxPlans$cycle.filter(item => category && categoryReg.test(item.category));
  if(!pbxPlans$cycle$category.length) {
    const preloadPlan = pbxPlans$cycle[0] || pbxCallingPlans[0];
    return addToCart(preloadPlan, 1);
  } else {
    return addToCart(pbxPlans$cycle$category[0], 1);
  }
}

const preloadDefaultPlan4Pbx = (boughtPlans = [], planList = []) => {
  const { from } = pageConfig;
  const { category_codes = [] } = planQueryParser(from || 'pbx_ZVU');
  const boughtPbxBasePlans = computedPbxBasePlans(boughtPlans);
  const billingCycle = getPbxBillingCycle(boughtPlans);
  const pbxBaseCode = category_codes.pop();

  // if user has pbx base plan
  if (!boughtPbxBasePlans.length) {
    for (let p of planList) {
      if (p.category === pbxBaseCode) {
        addToCart(p, 1);
        break;
      }
    }
  } else {
    boughtPbxBasePlans.forEach(p => addToCartByPlanCode(planList, p.plan_code, 1));
  }

  category_codes.forEach((category) => {
    const targetPlan = addZPCallingPlansByCategory(
      planList,
      category,
      billingCycle,
    )
    if (!targetPlan) return;
    const _currentQuantity = targetPlan?._currentQuantity || 0;
    targetPlan.cartInfo.selected_number = _currentQuantity + 1;
  });
  return planList;
};

const preloadDefaultZoneBundlePlan = (planList, boughtPlans, targetPlanType = planTypes.ZOOM_ONE_BUNDLE) => {
  const categoryPlanList = _.filter(planList, (p) => de$type(p.type) === targetPlanType);
  // Default base pbx plan
  const targetBillingCycle = getPbxBillingCycle(boughtPlans);
  // get plans by billing cycle
  const plans = _.chain(categoryPlanList)
  .filter((x) => x.billing_cycle === targetBillingCycle)
  .filter((x) => x.region === PBX_REGIONS.US_AND_CANADA)
  .value();

  const { from, from_sub } = pageConfig;
  const { category_codes = [] } = planQueryParser(from || from_sub);
  const categoryCode = category_codes[0];
  const categoryReg = new RegExp(`^${categoryCode}$`, 'i');
  const categoryPlans = _.filter(plans, item => categoryCode && categoryReg.test(item.category));

  let targetPlan = _.get(categoryPlans.length ? categoryPlans : plans, [0]);
  if (targetPlan) {
    const _currentQuantity = targetPlan?._currentQuantity || 0;
    addToCartByPlanCode(planList, targetPlan.plan_code, zoneBundleUtils.getBundlePlanDefaultLicense(targetPlanType) + _currentQuantity);
  }
  
  const boughtPbxBasePlans = computedPbxBasePlans(boughtPlans);
  if (!boughtPbxBasePlans.length) {
    const basePbxPlan = planList.find((p) => p.category === PBX_CATEGORYS.ZVP)
    basePbxPlan && addToCartByPlanCode(planList, basePbxPlan.plan_code, 1);
  } else {
    boughtPbxBasePlans.forEach(p => addToCartByPlanCode(planList, p.plan_code, 1));
  }

  return planList;
};

const injectCurrentQuantity = (planList, boughtPlans) => {
  planList.forEach(p => {
    const boughtPlan = boughtPlans.find(bp => bp.plan_code === p.plan_code);
    p._currentQuantity = boughtPlan?.cartInfo?.selected_number || 0;
  });
  return planList;
};

const loadDefaultSelectByQuery = (boughtPlans = []) => {
  return (planList = []) => {
    const hasSelected = planList?.find((p) => p.cartInfo.selected_number > 0);
    planList = injectCurrentQuantity(planList, boughtPlans);
    if (!hasSelected) {
      if (addType === planTypes.ZOOM_PHONE) {
        planList = preloadDefaultPlan4Pbx(boughtPlans, planList);
      } else if (addType === planTypes.ZONE_PRO_PLUS) {
        planList = preloadDefaultZoneBundlePlan(planList, boughtPlans, planTypes.ZONE_PRO_PLUS);
      } else if (zoneBundleUtils.isZoneBundleByPlanType(addType)) {
        planList = preloadDefaultZoneBundlePlan(planList, boughtPlans, addType);
      }
    }
    planList = addVendorProduct(planList)
    return planList;
  };
};

export default loadDefaultSelectByQuery
